var invalidStr = [];

export const ValidStringChecker = (invalidStrings, string) => {
  invalidStrings.map((str, i) => {
    if (string && string.includes(str.toString()) && invalidStr.indexOf(str) === -1) {
      invalidStr.push(str);
      return true;
    } else {
      return false;
    }
  });
  return invalidStr;
};
